import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import AppContext from "../../container/context";
import api from "../../services/api";
import { formatDateTime, mergeParams } from "../../helpers/helpers";
import RadioSituacao from "./components/Radio";
import ActionTable from "../../components/table/ActionTable";
import { Box, Grid } from "@mui/material";
import { CircularProgress } from "@mui/material";

export default function Lista({ history, location }) {
  const [filtros, setFiltros] = useState(
    mergeParams(
      {
        profissional: "",
        palavraChave: "",
        escola: "",
        unidade: "",
        cond: "ABERTOS",
      },
      location
    )
  );
  const [contadores, setContadores] = useState({});
  const [registros, setRegistros] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const { notification } = useContext(AppContext);

  useEffect(() => {
    listarMateriais();
  }, []);

  const listarMateriais = (filtrosEnviar = filtros) => {
    setCarregando(true);
    filtrosEnviar.cond = filtros.cond;
    setFiltros(filtrosEnviar);

    api.get("acompanhamento/contadores").then((res) => {
      setContadores(res);
    });

    api
      .get("acompanhamento/listar", filtrosEnviar)
      .then((res) => {
        const registros = res;
        registros.forEach((r) => {
          r.envio = formatDateTime(r.envio, "D/M/Y h:m:s");
          r.status = r.usuarioId
            ? "Aguardando resposta do profissional"
            : "Nova resposta";
          // r.customStyle = {
          //   backgroundColor: r.status === "Nova resposta" ? "#ffe4ad" : "",
          // };
        });
        setRegistros(registros);
        setCarregando(false);
      })
      .catch((e) => {
        notification(
          "error",
          "Não foi possível listar os acompanhamentos. Verifique sua conexão e tente novamente."
        );
        setCarregando(false);
      });
  };

  const fFiltros = {
    title: "Filtros",
    form: {
      profissional: {
        label: "Nome do profissional",
        type: "text",
        space: 4,
        value: filtros.profissional,
      },
      escola: {
        label: "Nome da escola",
        type: "text",
        space: 4,
        value: filtros.escola,
      },
      unidade: {
        label: "Nome da unidade",
        type: "text",
        space: 4,
        value: filtros.unidade,
      },
    },

    submit: {
      label: "Buscar",
      action: listarMateriais,
    },

    urlParams: true,
    history,
    location,
  };

  const mudarSituacao = (e) => {
    e.preventDefault();
    let atualizaDados = filtros;
    atualizaDados.cond = e.target.value;
    setCarregando(true);
    listarMateriais(atualizaDados);
  };

  const tRegistros = {
    title: "Acompanhamentos",
    onLineClick: (registro) =>
      history.push(
        `/app/acompanhamento/${registro.unidadeId}/${registro.profissionalId}`
      ),
    columns: [
      {
        label: "Profissional",
        name: "profissionalNome",
      },
      {
        label: "Escola",
        name: "escolaNome",
      },
      {
        label: "Ciclo",
        name: "cicloNome",
      },
      {
        label: "Unidade",
        name: "unidadeNome",
      },
      {
        label: "Último evento",
        name: "envio",
      },
      {
        label: "Situação",
        name: "status",
        condStyle: (item) =>
          !item.usuarioId
            ? { backgroundColor: "#FFD36E", fontWeight: "bolder" }
            : {},
      },
    ],
    array: registros,
  };

  return (
    <div>
      <Form formData={fFiltros} />
      <RadioSituacao
        mudarSituacao={mudarSituacao}
        dados={filtros}
        contadores={contadores}
      />

      {carregando ? (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          {registros.length > 0 ? (
            <ActionTable structure={tRegistros} />
          ) : (
            <Grid sx={{ textAlign: "center" }}>
              <h2>Nenhum registro encontrado com os filtros informados</h2>
            </Grid>
          )}
        </>
      )}
    </div>
  );
}
